// extracted by mini-css-extract-plugin
export default {"container":"quotation-items_container__PH7Pm","quotation-list-content":"quotation-items_quotation-list-content__bg+aQ"};